module.exports = __webpack_public_path__ + "static/img/CIB.4b83dbb9.png";